var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/heart-add"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heart-add"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.333 18.3334C16.5421 18.3334 18.333 16.5425 18.333 14.3334C18.333 12.1242 16.5421 10.3334 14.333 10.3334C12.1239 10.3334 10.333 12.1242 10.333 14.3334C10.333 16.5425 12.1239 18.3334 14.333 18.3334Z",
    stroke: "#FF8C42",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.8242 14.3834H12.8408",
    stroke: "#FF8C42",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.332 12.925V15.9167",
    stroke: "#FF8C42",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.3337 7.24161C18.3337 8.88327 17.9087 10.3332 17.242 11.5916C16.5087 10.8166 15.4753 10.3333 14.3337 10.3333C12.1253 10.3333 10.3337 12.1249 10.3337 14.3333C10.3337 15.3583 10.7253 16.2916 11.3587 17C11.0503 17.1416 10.767 17.2583 10.517 17.3416C10.2337 17.4416 9.767 17.4416 9.48366 17.3416C7.067 16.5166 1.66699 13.0749 1.66699 7.24161C1.66699 4.66661 3.74199 2.58325 6.30032 2.58325C7.80866 2.58325 9.15866 3.31662 10.0003 4.44162C10.842 3.31662 12.192 2.58325 13.7003 2.58325C16.2587 2.58325 18.3337 4.66661 18.3337 7.24161Z",
    stroke: "#FF8C42",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartAdd);
export default __webpack_public_path__ + "static/media/heartAdd.3e012546182ec08f72f601006edfd604.svg";
export { ForwardRef as ReactComponent };